import { useContext } from 'react';
import TableContext from '../context/TableContext';

export default function useTable() {
    return useContext(TableContext);
}
